module.exports = "<div id=\"footer\">\n  <div class=\"container80\">\n    &copy; 2018 DkRealty\n  </div>\n</div>\n"